// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  color: #FF2459 !important;
  border: 1px solid var(--Brand-Parimary, #FF2459) !important;
  background: var(--Brand-Light, #FFF2F2) !important;
}

.all-events-container {
  max-width: 1690px;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (max-width: 650px) {
  .all-events-container {
    max-width: 100% !important;
    width: 100% !important;
    height: auto;
    padding: 36px 24px !important;
    display: flex;
    position: relative;
    flex-direction: column;
    gap: 18px !important;
    margin: 0;
  }
  .search-bar-container {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    margin: 0;
    gap: 18px !important;
  }
  .header {
    display: flex;
    gap: 8px !important;
  }
  .heading {
    font-size: 24px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: 135% !important;
  }
  .eventList {
    gap: 18px !important;
  }
  .bt {
    display: flex;
    height: 36px !important;
    padding: 0px 20px !important;
    justify-content: center;
    align-items: center;
  }
  .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px !important;
  }
  .event-card-container {
    display: flex;
    gap: 24px !important;
    flex-wrap: wrap;
    align-items: center;
  }
  .event-card {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/all-events/style.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,2DAAA;EACA,kDAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;;AAGA;EAEI;IACI,0BAAA;IACA,sBAAA;IACA,YAAA;IACA,6BAAA;IACA,aAAA;IACA,kBAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;EADN;EAIE;IACI,sBAAA;IACA,aAAA;IACA,sBAAA;IACA,kCAAA;IACA,SAAA;IACA,oBAAA;EAFN;EAKE;IACI,aAAA;IACA,mBAAA;EAHN;EAME;IACI,0BAAA;IACA,6BAAA;IACA,2BAAA;IACA,4BAAA;EAJN;EAOE;IACI,oBAAA;EALN;EAQE;IACI,aAAA;IACA,uBAAA;IACA,4BAAA;IACA,uBAAA;IACA,mBAAA;EANN;EASE;IACI,aAAA;IACA,eAAA;IACA,mBAAA;EAPN;EAUE;IACI,aAAA;IACA,oBAAA;IACA,eAAA;IACA,mBAAA;EARN;EAWE;IACI,sBAAA;EATN;AACF","sourcesContent":[".btn{\n    color: #FF2459 !important;\n    border: 1px solid var(--Brand-Parimary, #FF2459) !important;\n    background: var(--Brand-Light, #FFF2F2) !important;\n}\n\n.all-events-container{\n    max-width: 1690px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n\n@media screen and (max-width: 650px) {\n\n    .all-events-container {\n        max-width: 100% !important;\n        width: 100% !important;\n        height: auto;\n        padding: 36px 24px !important;\n        display: flex;\n        position: relative;\n        flex-direction: column;\n        gap: 18px !important;\n        margin: 0;\n    }\n    \n    .search-bar-container {\n        width: 100% !important;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start !important;\n        margin: 0;\n        gap:18px !important;\n    }\n    \n    .header {\n        display: flex;\n        gap: 8px !important;\n    }\n\n    .heading{\n        font-size: 24px !important;\n        font-style: normal !important;\n        font-weight: 600 !important;\n        line-height: 135% !important;\n    }\n\n    .eventList{\n        gap:18px !important;\n    }\n\n    .bt{\n        display: flex;\n        height: 36px !important;\n        padding: 0px 20px !important;\n        justify-content: center;\n        align-items: center;\n    }\n    \n    .button-group {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 8px !important;\n    }\n    \n    .event-card-container {\n        display: flex;\n        gap: 24px !important;\n        flex-wrap: wrap;\n        align-items: center;\n    }\n    \n    .event-card {\n        width: 100% !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
